import React, { useContext } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  styled,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import studentBg from "../../../../../src/assets/img/student-icon.png";


const StyledCard = styled(Card)({
  marginBottom: 16,
  padding: "16px 12px",
  borderRadius: 24,
  background: "linear-gradient(to right, #f0f4ff, #ffffff)",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  transition: "all 0.2s ease-in-out",
  cursor: "pointer",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  height: "100%",
  position: "relative",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    right: 0,
    width: "100%",
    height: "100%",
    backgroundImage: `url(${studentBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "80px",
    backgroundPosition: "right bottom",
    opacity: 0.05,
    pointerEvents: "none",
    zIndex: 0,
    transition: "opacity 0.2s ease-in-out",
  },
  "&:hover": {
    transform: "scale(1.02)",
    background: "linear-gradient(to right, #e6edff, #f7f9ff)",
    "& .MuiTypography-root": {
      color: "rgba(15, 41, 85, 1)",
    },
    "&::before": {
      opacity: 0.15,
    }
  },
});

const StyledTypography = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  fontWeight: 700,
  color: "rgba(15, 41, 85, 0.8)",
  transition: "color 0.2s ease-in-out",
}));

const SecondaryText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(0.5),
  transition: "color 0.2s ease-in-out",
}));

interface StudentCardProps {
  name: string;
  rollNumber: string | number;
  displayName: string;
  studentId: string | number;
}

const StudentCard: React.FC<StudentCardProps> = ({
  name,
  rollNumber,
  displayName,
  studentId,
}) => {
  const navigate = useNavigate();
  const id = studentId;

 const handleClick = () => {
    localStorage.setItem("selectedStudentId", id.toString());
    navigate(`/dashboard/${id}`);
  };

  return (
    <StyledCard onClick={handleClick}>
      <CardContent>
        <StyledTypography variant="h6">{name}</StyledTypography>
        <Box>
          <SecondaryText variant="body2">
            <strong>Roll No:</strong> {rollNumber}
          </SecondaryText>
          <SecondaryText variant="body2">
            <strong>Class:</strong> {displayName}
          </SecondaryText>
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default StudentCard;
